import { render, staticRenderFns } from "./EdmontonSymptoms.vue?vue&type=template&id=6acc7408&"
import script from "./EdmontonSymptoms.vue?vue&type=script&lang=js&"
export * from "./EdmontonSymptoms.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/views/dashboard/members/id/edmonton-symptoms.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports